export default function HeroSection() {
  return (
    <section
      data-testid="hero-section"
      className="animate-stagger-2 relative overflow-hidden"
    >
      {/* Background image with gradient overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1663735498345-39c452a6d5d8?w=800&q=60"
          alt=""
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="hero-gradient absolute inset-0" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center px-6 py-16 md:py-24">
        <img
          src="https://customer-assets.emergentagent.com/job_union-fe/artifacts/8pz6jquk_LOGO%20Iglesia%20Blanco%203.png"
          alt="Tu Iglesia App"
          data-testid="hero-logo"
          className="w-44 md:w-56 mb-8 drop-shadow-2xl animate-float"
        />

        <h1
          data-testid="hero-title"
          className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-tight"
        >
          Tu fe, siempre contigo
        </h1>

        <p
          data-testid="hero-subtitle"
          className="font-accent text-base md:text-lg text-white/80 max-w-sm leading-relaxed"
        >
          Conéctate con tu congregación, accede a la Palabra y crece en
          comunidad desde tu celular.
        </p>
      </div>
    </section>
  );
}
